import { Asset } from './Assets'
import { Platform } from './Platform'

export class PaymentAccount {
    id: string | null = null
    webhook_api_key: string | null = null
    payment_reference_prefix: string | null = null
    type: string | null = null
    name: string | null = null
    description: string | null = null
    payment_endpoint: string | null = null
    auth_endpoint: string | null = null
    api_endpoint: string | null = null
    api_token: string | null = null
    client_id: string | null = null
    client_secret: string | null = null
    master_contract_id: string | null = null
    checkout_template_id: string | null = null
    sync_enabled = false
    currency: string | undefined = undefined
    deposit_account_holder: string | null = null
    deposit_iban: string | null = null
    deposit_bic: string | null = null
    limit_credit_card_order: number | null = 0
    limit_credit_card_deposit: number | null = 0
    limit_bank_transfer_order: number | null = 0
    limit_bank_transfer_deposit: number | null = 0
    limit_bank_transfer_withdrawal: number | null = 0
    deposit_account_holder_address: string | null = null
    deposit_account_holder_country: string | null = null
    healthcheck_wallet: string | null = null
    uses_proxy = false
    created_at: Date | null = null
    updated_at: Date | null = null
    platforms: Platform[] | null = null
    assets: Asset[] | null = null
    can_deposit = false
    can_withdraw = false
    logo_url: string | null = null
    stakeholder_fee: number | null = null
    enable_stakeholder_payment = false
    stakeholder_contract_id: string | null = null
}

export class PaymentAccountDetails extends PaymentAccount {}
